import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=33ac6964&scoped=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&id=33ac6964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac6964",
  null
  
)

export default component.exports